import React from 'react';

import { useDeviceType } from '../../hooks';
import { ErrorView } from '../error-view';
import { RootErrorFallbackProps } from './types';

/**
 * Fallback for the app-level boundary, which sits above <RouterProvider>.
 * Navigates via window.location because router hooks are unavailable here.
 */
export const RootErrorFallback = ({ error }: RootErrorFallbackProps): React.ReactElement => {
  const deviceType = useDeviceType();

  return (
    <ErrorView
      error={error}
      isMobile={deviceType === 'mobile'}
      onReturnHome={() => {
        window.location.href = '/';
      }}
      onReload={() => window.location.reload()}
    />
  );
};
